<template>
    <!-- «Скибка з перчиком»: під однією скибкою перчик, гравці по черзі тицяють у скибки.
         Скибок — кратно кількості гравців (8–14), тож у кожного однаково ходів і шансів -->
    <div class="bp-wp-game">
        <p class="bp-wp-turn" aria-live="polite">
            <template v-if="found === null">Хід: <b>{{ players[turn % players.length] }}</b> — обери скибку</template>
            <template v-else>Перчик дістався: <b>{{ players[turn % players.length] }}</b>!</template>
        </p>
        <p class="bp-wp-hint" v-if="found === null">{{ lastSafe ? lastSafe + ' — пронесло! ' : '' }}Під однією зі скибок — гострий перчик</p>
        <div class="bp-wp-pizza" :class="{ 'is-boom': found !== null }">
            <img v-if="photo" :src="photo" alt="" class="bp-wp-pizza__img">
            <svg viewBox="0 0 300 300" class="bp-wp-pizza__svg" role="group" aria-label="Скибки піци">
                <circle v-if="!photo" cx="150" cy="150" r="140" fill="#f3d29a" stroke="#d9a15a" stroke-width="10"/>
                <path v-for="slice in slices" :key="slice.i" :d="slice.d" class="bp-wp-slice"
                      :class="{ 'is-eaten': picked.includes(slice.i) && slice.i !== pepper, 'is-pepper': found !== null && slice.i === pepper }"
                      role="button" :tabindex="canPick(slice.i) ? 0 : -1" :aria-label="'Скибка ' + (slice.i + 1)"
                      @click="pick(slice.i)" @keydown.enter.prevent="pick(slice.i)" @keydown.space.prevent="pick(slice.i)"/>
            </svg>
            <span v-for="slice in revealed" :key="'m' + slice.i" class="bp-wp-mark" :class="{ 'bp-wp-mark--pepper': slice.i === pepper }"
                  :style="{ left: slice.cx / 3 + '%', top: slice.cy / 3 + '%' }" v-html="slice.i === pepper ? chili : icons.check"></span>
        </div>
    </div>
</template>

<script>
import { ICONS } from '@/v2icons'
import { CHILI } from './chili'

export default {
    name: 'GamePepper',
    props: {
        players: { type: Array, required: true },
        photo: { type: String, default: '' }
    },
    data() {
        const n = this.players.length;
        const count = n * Math.ceil(8 / n);
        return {
            icons: ICONS,
            chili: CHILI,
            count,
            pepper: Math.floor(Math.random() * count),
            picked: [],
            turn: 0,
            found: null,
            lastSafe: ''
        }
    },
    computed: {
        slices() {
            const step = 2 * Math.PI / this.count, r = 140, c = 150;
            return Array.from({ length: this.count }, (_, i) => {
                const a0 = -Math.PI / 2 + i * step, a1 = a0 + step, am = a0 + step / 2;
                const p = a => [(c + r * Math.cos(a)).toFixed(2), (c + r * Math.sin(a)).toFixed(2)];
                const [x0, y0] = p(a0), [x1, y1] = p(a1);
                return { i, d: `M${c} ${c}L${x0} ${y0}A${r} ${r} 0 0 1 ${x1} ${y1}Z`, cx: c + r * .62 * Math.cos(am), cy: c + r * .62 * Math.sin(am) };
            });
        },
        revealed() {
            return this.slices.filter(slice => this.picked.includes(slice.i));
        }
    },
    methods: {
        canPick(i) {
            return this.found === null && !this.picked.includes(i);
        },
        pick(i) {
            if (!this.canPick(i)) return;
            this.picked.push(i);
            const who = this.players[this.turn % this.players.length];
            if (i === this.pepper) {
                this.found = i;
                setTimeout(() => this.$emit('done', { loser: this.turn % this.players.length, note: 'Перчик на ' + this.picked.length + '-й скибці' }), 1300);
                return;
            }
            this.lastSafe = who;
            this.turn++;
        }
    }
}
</script>
